import { FC, Fragment } from 'react';
import { PerformMultiSelect } from '../perform-indicator/perform-indicator';
import * as Styles from './segment-parts.module.less';

interface SmsCampaignLocationProps {
    locationZipCodes?: string[] | undefined;
    zones?: string[] | undefined;
    locationTags?: string[] | undefined;
    cities?: string[] | undefined;
}

export const SmsCampaignLocation: FC<SmsCampaignLocationProps> = ({
    locationZipCodes,
    zones,
    locationTags,
    cities,
}) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Location</div>
        <div>
            <PerformMultiSelect name="Zone" value={zones} />
            <PerformMultiSelect name="City" value={cities} />
            <PerformMultiSelect name="Zip Code" value={locationZipCodes} />
            <PerformMultiSelect name="Location Tags" value={locationTags} />
        </div>
    </Fragment>
);
